const adjustFont = () => {
  const font = document.querySelectorAll('.js-font')

  for(let item of font) {
    item.addEventListener('click', () => {
      for(let itemInner of font) {
        itemInner.classList.remove('active')
      }
      item.classList.add('active')
      document.body.classList.toggle('zoom')
    })
  }
}

export default adjustFont